<script>
export default {
  name: 'DecryptedInfo',
  props: {
    decryptedPayload: {
      type: Object,
      required: true
    },
    shippingAddress: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      srcTokenResultsData: {},
      dynamicData: {},
      payloadShippingAddress: {},
      billingAddress: {},
      paymentTokenDetails: {}
    }
  },
  created () {
    this.srcTokenResultsData = this.decryptedPayload.srcTokenResultsData || {}
    this.dynamicData = this.decryptedPayload.dynamicData || {}
    this.payloadShippingAddress = this.decryptedPayload.shippingAddress || {}
    this.billingAddress = this.decryptedPayload.billingAddress || {}
    this.paymentTokenDetails = this.decryptedPayload.token || {}
  }
}
</script>

<template>
  <div id="decrypted-payment-info">
    <div class="card mb-2">
      <h5
        aria-controls="decryptedConsumerDetails"
        aria-expanded="false"
        class="collapsed card-header cursor-pointer"
        data-target="#decryptedConsumerDetails"
        data-toggle="collapse"
      >
        <span>{{ $t ('label.consumerDetails') }}</span>
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>
      <div
        id="decryptedConsumerDetails"
        class="collapse card-body"
      >
        <p>
          <span> {{ $t ('label.firstName') }} : </span>
          <span>{{ decryptedPayload.consumerFirstName }}</span>
        </p>
        <p>
          <span> {{ $t ('label.lastName') }} : </span>
          <span>{{ decryptedPayload.consumerLastName }}</span>
        </p>
        <p>
          <span> {{ $t ('label.emailId') }} :  </span>
          <span>{{ decryptedPayload.consumerEmailAddress }}</span>
        </p>
        <p>
          <span> {{ $t ('label.mobileNum') }} :  </span>
          <span>{{ (decryptedPayload.consumerMobileNumber || {}).phoneNumber }}</span>
        </p>
        <p>
          <span>{{ $t ('label.countryCode') }} : </span>
          <span> {{ (decryptedPayload.consumerMobileNumber || {}).countryCode }}</span>
        </p>
      </div>
    </div>

    <div class="card mb-2">
      <h5
        aria-controls="decrytedPaymentToken"
        aria-expanded="false"
        class="collapsed card-header cursor-pointer"
        data-target="#decrytedPaymentToken"
        data-toggle="collapse"
      >
        <span>{{ $t ('label.paymentToken') }}</span>
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>

      <div
        id="decrytedPaymentToken"
        class="card-body collapse"
      >
        <div
          v-for="(value,key) in paymentTokenDetails"
          id="paymentTokenDetails-info"
          :key="key"
          :value="value"
          data-test="paymentTokenDetails-info"
        >
          <p>
            <span class="text-capitalize">{{ key.replace(/([a-z])([A-Z])/g, '$1 $2') }} : {{ value }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="card mb-2">
      <h5
        aria-controls="dynamicData"
        aria-expanded="false"
        class="collapsed card-header cursor-pointer"
        data-target="#dynamicData"
        data-toggle="collapse"
      >
        <span>{{ $t ('label.dynamicData') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>
      <div
        id="dynamicData"
        class="card-body collapse"
      >
        <div
          v-for="(value,key) in dynamicData"
          id="dynamicData-info"
          :key="key"
          :value="value"
          data-test="dynamicData-info"
        >
          <p>
            <span class="text-capitalize">{{ key.replace(/([a-z])([A-Z])/g, '$1 $2') }} : {{ value }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="card mb-2">
      <h5
        aria-controls="srcTokenResultsData"
        aria-expanded="false"
        class="collapsed card-header cursor-pointer"
        data-target="#srcTokenResultsData"
        data-toggle="collapse"
      >
        <span>{{ $t ('label.srcTokenResultsData') }}</span>
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>
      <div
        id="srcTokenResultsData"
        class="card-body collapse"
      >
        <div
          v-for="(value,key) in srcTokenResultsData"
          id="srcTokenResultsData-info"
          :key="key"
          :value="value"
          data-test="srcTokenResultsData-info"
        >
          <p>
            <span class="text-capitalize">{{ key.replace(/([a-z])([A-Z])/g, '$1 $2') }} : {{ value }}</span>
          </p>
        </div>
        <div v-if="!decryptedPayload.srcTokenResultsData">
          <p>
            <span>{{ $t ('label.key') }} : </span>
          </p>
          <p>
            <span>{{ $t ('label.value') }} : </span>
          </p>
        </div>
      </div>
    </div>

    <div class="card mb-2">
      <h5
        aria-controls="decryptedShippingDetails"
        aria-expanded="false"
        class="collapsed card-header cursor-pointer"
        data-target="#decryptedShippingDetails"
        data-toggle="collapse"
      >
        <span>{{ $t ('label.shippingDetails') }}</span>
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>

      <div
        id="decryptedShippingDetails"
        class="collapse card-body"
      >
        <div v-if="shippingAddress === 'FULL' && shippingAddress != 'NONE'">
          <div
            v-for="(value,key) in payloadShippingAddress"
            id="payloadShippingAddress-info"
            :key="key"
            :value="value"
            data-test="payloadShippingAddress-info"
          >
            <p>
              <span class="text-capitalize">{{ key.replace(/([a-z])([A-Z])/g, '$1 $2') }} : {{ value }}</span>
            </p>
          </div>
        </div>
        <div v-if="shippingAddress === 'POSTAL_COUNTRY' && shippingAddress != 'NONE'">
          <p>
            <span>{{ $t ('label.shippingCountryCode') }} : </span>
            <span> {{ billingAddress.countryCode }}</span>
          </p>
          <p>
            <span>{{ $t ('label.shippingAddressZip') }} : </span>
            <span> {{ billingAddress.zip }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="card mb-2">
      <h5
        aria-controls="decryptedBillingAddress"
        aria-expanded="false"
        class="collapsed card-header cursor-pointer"
        data-target="#decryptedBillingAddress"
        data-toggle="collapse"
      >
        <span>{{ $t ('label.billingAddressDetails') }}</span>
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>

      <div
        id="decryptedBillingAddress"
        class="card-body collapse"
      >
        <div
          v-for="(value,key) in billingAddress"
          id="billingAddress-info"
          :key="key"
          :value="value"
          data-test="billingAddress-info"
        >
          <p>
            <span class="text-capitalize">{{ key.replace(/([a-z])([A-Z])/g, '$1 $2') }} : {{ value }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
